export const INTEGRATION_SYNC_UPDATED_EVENT = 'cn:integration-sync-updated'

export const notifyIntegrationSyncUpdated = () => {
  if (typeof window === 'undefined') {
    return
  }
  window.dispatchEvent(new Event(INTEGRATION_SYNC_UPDATED_EVENT))
}
